import text from './resources/locale/en.json';

class ExtensionsBuilderController {
    $onInit() {
        this.text = text;
    }
}

export default ExtensionsBuilderController;
